// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3568":"f8ef558fc35c09ef","5782":"5d68785961ea5f0e","7747":"8c96ab60fea34cef","8680":"026eb3e523931ef5","9502":"6f056415abfae9b4"}[chunkId] + ".css";
};